export const socialMedias = {
  whatsapp: {
    name: 'WhatsApp',
    code: 'whatsapp'
  },
  instagram: {
    name: 'Instagram',
    code: 'instagram'
  },
  facebook: {
    name: 'Facebook',
    code: 'facebook'
  },
  twitter: {
    name: 'X/Twitter',
    code: 'twitter'
  },
  tiktok: {
    name: 'TikTok',
    code: 'tiktok'
  },
  youtube: {
    name: 'YouTube',
    code: 'youtube'
  },
  copy: {
    name: 'Salin Tautan',
    code: 'copy'
  }
}

export const socialMediaShareLinks = {
  whatsapp: {
    name: 'WhatsApp',
    link: 'https://api.whatsapp.com/send?text='
  }
}

export const getShareLinkSocialMediaUrl = (socialMedia, message) => {
  return `${socialMediaShareLinks[socialMedia].link}${encodeURIComponent(message)}`
}
